<template>
    <v-container v-if="this.zamawiajacy" class="page">
  <table>
    <thead>
    <tr><td>
  
  <div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
    <div class="left-cointainer">
      <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
    </div>
    <div class="right-cointainer">
      Tutore Poland Sp. z o.o.<br>
      ul. Piotrkowska 157A, 90-440 Łódź<br>
      NIP: 7272812193
    </div>
  </div>
  
    </td></tr>
    </thead>
  <tbody>
  <tr><td>
  
  <p align="center" style="margin-top:20px;">
      <strong>UMOWA ZLECENIE 1/UZ/{{ shortNrUmowy() }}/Menedżer Sprzedaży/2023</strong>
  </p>
  <p>Niniejsza umowa cywilnoprawna („<strong>Umowa</strong>”) została zawarta w Łodzi, w dniu {{ aktualnaData() }} roku, pomiędzy:</p>
    <p><strong>Tutore Poland Sp. z o.o.</strong> z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Łódź, wpisaną do Rejestru Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy dla Łodzi-Śródmieścia w Łodzi, XX Wydział Krajowego Rejestru Sądowego pod nr KRS 0000670834, NIP: 727-28-12-193, REGON: 366891567,</p>
    <p>reprezentowaną przez:</p>
    <p>{{ zamawiajacy }}, zwaną dalej <strong>„Zleceniodawcą”</strong>,</p>
    <p>a</p>
    <p>{{ imieNazwisko }} zam. w {{ miejscowosc }} (kod {{ kodPocztowy }}) przy ul. {{ ulica }} {{ nrDomu }} <span v-if="nrLokalu !== ''">/</span> {{ nrLokalu }}, PESEL {{pesel}},</p>
    <p>zwaną/ym dalej „<strong>Zleceniobiorcą</strong>”</p>
    <p>o następującej treści:</p>
    <br/>
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 1 [Przedmiot umowy]</strong>
  </p>
  <ol>
    <li>Zleceniodawca zleca a Zleceniobiorca zobowiązuje się do wykonywania czynności polegających na sprzedaży produktów edukacyjnych Zleceniodawcy oraz rozwoju sieci usług Zleceniodawcy na powierzonym obszarze (dalej <strong>Czynności</strong>).</li>
    <li>Zleceniobiorca oświadcza, że zapoznał się z misją i wizją Zleceniodawcy, przyjętymi u Zleceniodawcy standardami oraz obowiązującymi u Zleceniodawcy regulacjami wewnętrznymi oraz że w razie dokonania ich zmian, zmiany te będą skuteczne pomiędzy stronami. W szczególności, podczas wykonywania zlecenia, Zleceniobiorca zobowiązany jest do dbania o dobro Zleceniodawcy i ochronę jego mienia, w tym do dołożenia najwyższej staranności celem zapewnienia zgodności wszystkich podejmowanych czynności z odpowiednimi politykami, standardami, wytycznymi, kodeksami branżowymi i procedurami (dalej łącznie: „<strong>Dokumenty</strong>”) obowiązującymi u Zleceniodawcy, które zostaną Zleceniobiorcy udostępnione. Zleceniodawca zobowiązuje Zleceniobiorcę do postępowania zgodnie z zasadami zawartymi w Dokumentach, a ich nieprzestrzeganie może być podstawą do rozwiązania niniejszej umowy w trybie natychmiastowym, z przyczyn leżących po stronie Zleceniobiorcy.</li>
    <li>Szczegółowy zakres czynności Zleceniobiorcy wskazany jest w <strong>Załączniku nr 1</strong> do Umowy.</li>
    <li>Zleceniobiorca nie może powierzyć wykonania przedmiotu niniejszej umowy osobie trzeciej.</li>
    <li>Zleceniobiorca oświadcza, że posiada wiedzę i doświadczenie, które zapewnią należyte i terminowe wywiązanie się z postanowień niniejszej umowy. Zleceniobiorca oświadcza, że zobowiązuje się wykonywać Umowę ze szczególną starannością z uwzględnieniem obowiązujących przepisów prawa, standardów i reguł wykonywania prac objętych niniejszym zleceniem, a także zasad etyki zawodowej oraz dbając o interesy Zleceniodawcy.</li>
    <li>Obszarem realizacji czynności przez Zleceniobiorcę jest {{ oddzial }}.</li>
    <li>Przy realizacji Czynności Zleceniobiorca może posługiwać się tytułem Menadżer Sprzedaży usług edukacyjnych TUTORE.</li>
  </ol>
  <br>
  
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 2 [Zasady świadczenia Usług]</strong>
  </p>
  <ol>
    <li>Zleceniobiorca wykona powierzone czynności z dołożeniem należytej staranności.</li>
    <li>Zleceniobiorca samodzielnie decyduje o sposobie, terminie i miejscu wykonania swoich obowiązków wynikających z umowy. W przypadku wykonywania obowiązków w siedzibie Zleceniodawcy, Zleceniobiorca będzie je wykonywał w dni robocze.</li>
    <li>Zleceniodawca zapewni Zleceniobiorcy dostęp do informacji i dokumentów, które będą niezbędne do wykonania umowy. Zleceniobiorca  będzie  posługiwał  się  materiałami  informacyjnymi dostarczonymi  przez  Zleceniodawcę.</li>
    <li>Na  koniec  każdego  tygodnia Zleceniobiorca złoży Zleceniodawcy za pośrednictwem e-mail (na adres e-mail upoważnionego przedstawiciela Zleceniodawcy, o którym mowa w § 9 ust. 5 Umowy), <strong>raport</strong> zawierający zestawienie wykonanych czynności ze wskazaniem nazwy i adresu klientów. Zestawienie obejmie czynności wykonane przez Zleceniobiorcę oraz zarządzany przez niego zespół.</li>
    <li>Z uwagi na charakter świadczonych usług oraz w trosce o zachowanie  wysokiej renomy Zleceniodawcy, Zleceniodawca jest uprawniony do nadzorowania sposobu wykonywania usług przez Zleceniobiorcę oraz wydawania mu wiążących wskazówek.</li>
    <section v-if="sprzetSluzbowy">
      <li>W celu prawidłowego wykonania usług stanowiących przedmiot umowy, Zleceniodawca  udostępnia Zleceniobiorcy <strong>telefon wraz z kartą SIM oraz komputer wraz z oprogramowaniem.</strong> Na zasadach określonych w odrębnej umowie Zleceniodawca może powierzyć Zleceniobiorcy <strong>sprzęt audiowizualny do wykonania Usług.</strong></li>
      <li>Przekazanie i zwrot przez Zleceniobiorcę sprzętu udostępnionego przez Zleceniodawcę potwierdzone zostaną protokołem odbioru i protokołem zwrotu podpisanym przez obie strony.</li>
      <li>Zleceniobiorca ma prawo korzystać z udostępnionego sprzętu wyłącznie do celów realizacji umowy.</li>
      <li>Zleceniobiorca zwróci Zleceniodawcy sprzęt, o którym mowa ust. 6 powyżej w dniu rozwiązania umowy, a także na każde pisemne żądanie Zleceniodawcy. Zleceniobiorca ponosi odpowiedzialność za zniszczenie lub uszkodzenie udostępnionego sprzętu.</li>
    </section>
    <section v-else>
      <li>Zleceniobiorca zobowiązany jest zorganizować sprzęt elektroniczny (telefon, komputer, sprzęt nagłaśniający, itp.) niezbędny do zrealizowania przedmiotu umowy, na własny koszt.</li>
    </section>
    <li>Strony zgodnie oświadczają, że wynagrodzenie Zleceniobiorcy z tytułu wykonywania niniejszej umowy zostało skalkulowane w taki sposób, że uwzględnia wykorzystywanie przez Zleceniobiorcę środków technicznych oraz powierzonego sprzętu.</li>
    <li>W czasie obowiązywania niniejszej Umowy Zleceniobiorca zobowiązuje się do odbywania szkoleń określonych przez Zleceniodawcę pod rygorem  zapłaty kary umownej w wysokości 1.000 (słownie: jeden tysiąc 0/100) złotych za każde nieodbyte lub odbyte nieterminowo szkolenie.</li>
  </ol>
  <br>
  
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 3 [Pełnomocnictwo]</strong>
  </p>
  <ol>
    <li>Zleceniodawca na potrzeby wykonywania niniejszej Umowy, udzieli Zleceniobiorcy pełnomocnictwa do zawierania umów i wykonywania czynności w zakresie i na zasadach określonych niniejszą umową oraz dokumentem pełnomocnictwa, stanowiącym <strong>załącznik nr 4</strong> do umowy.</li>
    <li>Zleceniobiorca nie może udzielać  dalszych  pełnomocnictw.</li>
    <li>Zleceniobiorca  będzie  zawierał  w  imieniu  Zleceniodawcy  umowy  wyłącznie  na  warunkach (w tym finansowych) określonych  przez  Zleceniodawcę. Zleceniodawca zobowiązuje się do informowania Zleceniobiorcy o zmianie warunków z odpowiednim wyprzedzeniem.</li>
    <li>Zleceniobiorca będzie zawierał  umowy z klientami wskazanymi przez Zleceniodawcę oraz z klientami pozyskanymi przez siebie w okresie obowiązywania niniejszej Umowy.</li>
    <li>Zleceniobiorca zobowiązany jest do informowania Zleceniodawcy o zawartych umowach niezwłocznie, nie później niż w terminie 2 dni roboczych od daty ich zawarcia.</li>
    <li>Zleceniobiorca zobowiązuje się do korzystania z pełnomocnictwa wyłącznie w jego granicach oraz do powstrzymania się od wszelkich czynności wykraczających poza zakres pełnomocnictwa.</li>
    <li>Pełnomocnictwo wskazane w ust. 1 powyżej może być w każdym czasie odwołane.</li>
    <li>Rozwiązanie umowy jest jednoznaczne z odwołaniem pełnomocnictwa.</li>
    <li>Po odwołaniu pełnomocnictwa Zleceniobiorca zobowiązany jest do zwrotu dokumentu pełnomocnictwa.</li>
  </ol>
  <br>

  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 4 [Czas trwania i rozwiązanie Umowy]</strong>
  </p>
    <ol>
      <li>Strony zawierają umowę od dnia {{ umowaOd }} do dnia {{ umowaDo }}.</li>
      <li>Zleceniodawcy oraz Zleceniobiorcy przysługuje prawo wypowiedzenia Umowy w każdym czasie, bez podania przyczyny, z zachowaniem miesięcznego okresu wypowiedzenia, ze skutkiem prawnym na koniec następnego miesiąca kalendarzowego, z tym zastrzeżeniem, że jeżeli Umowa zawarta jest na okres krótszy niż jeden miesiąc, okres wypowiedzenia wynosi 7 dni. Oświadczenie o wypowiedzeniu umowy wymaga zachowania formy pisemnej.</li>
      <li>Zleceniodawca może rozwiązać niniejszą umowę ze skutkiem natychmiastowym, w przypadku:
        <ol type="a">
          <li>niewykonywania lub nienależytego wykonywania przez Zleceniobiorcę Czynności objętych niniejszą umową,</li>
          <li>dopuszczenia się przez Zleceniobiorcę naruszenia postanowień § 7 lub 8 niniejszej Umowy,</li>
          <li>dopuszczenia się przez Zleceniobiorcę uporczywego lub rażącego naruszenia postanowień niniejszej Umowy bądź właściwych przepisów prawa, przy czym w takim wypadku Zleceniodawca obowiązany jest wskazać Zleceniobiorcy w formie pisemnej jasne i szczegółowe wyjaśnienie powstałych naruszeń i uzasadnić tym samym podstawę rozwiązania Umowy.</li>
        </ol>
      </li>
      <li>Zleceniobiorca może rozwiązać niniejszą umowę ze skutkiem natychmiastowym w przypadku pozostawania przez Zleceniodawcę w zwłoce z zapłatą wynagrodzenia przez okres dłuższy niż 30 dni.</li>
      <li>Z chwilą rozwiązania lub wygaśnięcia Umowy, najpóźniej w ostatnim dniu obowiązywania Umowy, Zleceniobiorca zobowiązany jest zwrócić Zleceniodawcy wszelkie przekazane mu przez Zleceniodawcę na potrzeby realizacji Czynności materiały, sprzęt i narzędzia, pod rygorem zapłaty kary umownej w wysokości 1 000 złotych za każdy rozpoczęty dzień opóźnienia lub zwłoki w realizacji ww. zobowiązania.</li>
    </ol>
  <br>
  
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 5 [Wynagrodzenie]</strong>
  </p>
  <ol>
    <li>Zleceniodawca zobowiązuje się do wypłaty, z tytułu właściwego wykonywania przedmiotu Umowy za dany miesiąc kalendarzowy wynagrodzenia w wysokości {{ kwota }} zł brutto (słownie: {{ slownieKwota }} złotych brutto) za każdą godzinę zegarową świadczonych na rzecz Zleceniodawcy Czynności.</li>
    <li>Całkowite miesięczne wynagrodzenie będzie wynikać ze stawki godzinowej wynikającej z ust. 1 niniejszego paragrafu oraz liczby godzin zrealizowanego zlecenia w danym miesiącu, na podstawie <span style="text-decoration: underline;">zaakceptowanego przez Zleceniodawcę Zestawienia liczby godzin</span> świadczonych Czynności w miesiącu, za który dokonywana jest płatność, o którym mowa w ust. 4 poniżej.</li>
    <li>Maksymalna liczba godzin wykonywania zlecenia wynosi {{ maksimumGodzin }}  godzin w miesięcznym okresie rozliczeniowym. W przypadku osiągnięcia przez Zleceniobiorcę maksymalnej liczby godzin, jest on zobowiązany do niezwłocznego poinformowania o tym Zleceniodawcy celem ustalenia zasadności przekroczenia limitu godzinowego oraz zasad wynagrodzenia Zleceniobiorcy za godziny wykonane ponad limitem godzin. Zaniechanie poinformowania Zleceniodawcy będzie skutkowało odmową wypłaty wynagrodzenia za godziny przekraczające wyznaczony limit.</li>
    <li>Zleceniobiorca przedstawia Zleceniodawcy zestawienie liczby godzin świadczenia Czynności przez Zleceniobiorcę w każdym miesiącu kalendarzowym, w którym Czynności były wykonywane (dalej: „<strong>Zestawienie liczby godzin</strong>”) za pośrednictwem narzędzi do ewidencjonowania godzin udostępnionych przez Zleceniodawcę, najpóźniej do 1-ego dnia miesiąca następującego po miesiącu kalendarzowym, którego ww. Zestawienie liczby godzin dotyczy. Jeżeli w danym miesiącu obowiązywania Umowy Czynności nie były wykonywane Zleceniobiorca informuję o tym Zleceniodawcę za pośrednictwem poczty elektronicznej (na adres e-mail upoważnionego przedstawiciela Zleceniodawcy, o którym mowa w § 9 ust. 5 Umowy).</li>
    <li>Zleceniodawca nie później niż w terminie 5 dni od otrzymania zestawienia liczby godzin potwierdza albo odmawia potwierdzenia liczby godzin świadczenia Czynności. Informacja o potwierdzeniu albo odmowie potwierdzenia jest przekazywana Zleceniobiorcy za pośrednictwem poczty elektronicznej. Zleceniobiorca w terminie 2 dni od daty przekazania przez Zleceniodawcę odmowy potwierdzenia liczby godzin świadczenia Czynności w danym miesiącu może wnieść reklamację do Zleceniodawcy, za pośrednictwem poczty elektronicznej lub pisemnie. W terminie 3 dni roboczych od daty otrzymania reklamacji Zleceniodawca informuje Zleceniobiorcę o sposobie rozpoznania reklamacji za pośrednictwem poczty elektronicznej lub w formie pisemnej.</li>
    <li>Wynagrodzenie Zleceniobiorcy będzie płatne z dołu w cyklu miesięcznym do 15-tego dnia każdego miesiąca, przelewem na numer konta bankowego wskazanego przez Zleceniobiorcę.</li>
  </ol>
  <br>
  
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 6 [Świadczenia dodatkowe]</strong>
  </p>
  <ol>
    <li>Strony zgodnie ustalają, że Zleceniobiorca może otrzymać dodatkowe wynagrodzenie w postaci premii, prowizji lub nagrody, na zasadach obowiązujących u Zleceniodawcy. Informacja o zasadach dodatkowego wynagrodzenia będzie przekazywana Zleceniobiorcy przez Zleceniodawcę pisemnie lub za pośrednictwem poczty elektronicznej. W szczególności dodatkowe wynagrodzenie może zostać przyznane za realizację wyznaczonych przez Zleceniodawcę celów budżetowych/jakościowych.</li>
    <li>Zleceniodawca oświadcza, a Zleceniobiorca akceptuje, że warunkiem wypłaty dodatkowego wynagrodzenia jest bezwzględne przestrzeganie przez Zleceniobiorcę zasad compliance obowiązujących u Zleceniodawcy. Jakiekolwiek, chociażby jednorazowe naruszenie tych zasad może skutkować pozbawieniem Zleceniobiorcy dodatkowego wynagrodzenia.</li>
    <li>Wynagrodzenie oraz wynagrodzenie dodatkowe, z zastrzeżeniem ust. 4-5 poniżej stanowią całość zobowiązań Zleceniodawcy wobec Zleceniobiorcy z tytułu wykonania niniejszej Umowy, w czasie jej trwania jak również po jej rozwiązaniu lub wygaśnięciu.</li>
    <li>Zleceniodawca pokrywa koszty przejazdu pociągiem (II klasa PKP) lub autobusem i noclegów Zleceniobiorcy, poza miejscem jego zamieszkania, związanych z wykonywaniem Usług, pod warunkiem ich wcześniejszej akceptacji przez Zleceniodawcę. Rozliczenie ww. kosztów następuje pod warunkiem dostarczenia Zleceniodawcy dokumentów potwierdzających fakt ich poniesienia przez Zleceniobiorcę.</li>
    <li>Za korzystanie z prywatnego samochodu Zleceniobiorcy dla celów realizacji Usług przysługuje zwrot kosztów w formie ryczałtu miesięcznego w wysokości wynikającej z iloczynu przejechanych kilometrów zgodnie z informacją, o której mowa w ust. 6 poniżej oraz stawki w wysokości 1,15 złotych brutto za 1 km. Strony ustalają limit w wysokości 500 km miesięcznie.</li>
    <li>W ostatnim dniu miesiąca kalendarzowego Zleceniobiorca przekaże Zleceniodawcy informację o liczbie kilometrów przejechanych w danym miesiącu w ramach realizacji obowiązków wynikających z niniejszej umowy. Informacja o liczbie kilometrów  podlega weryfikacji Zleceniodawcy.</li>
    <li>Zleceniobiorca zobowiązuje się do przekazywania Zleceniodawcy wszelkich informacji niezbędnych dla prawidłowego obliczenia i odprowadzenia składek na ubezpieczenia społeczne oraz ubezpieczenie zdrowotne Zleceniobiorcy, oraz ich aktualizacji. Zleceniobiorca ponosi odpowiedzialność za nieprawidłowe lub nieterminowe przekazanie informacji, o których mowa w zdaniu poprzednim.</li>
    <li>Zleceniobiorca wyraża zgodę na potrącenie z należnego mu wynagrodzenia kwoty kar umownych przewidzianych Umową.</li>
  </ol>
  <br>
  <br>

  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 7 [Klauzula poufności]</strong>
  </p>
  <ol>
    <li>Zleceniobiorca jest zobowiązany do zachowania w poufności wszelkich informacji, jak również wszelkich dokumentów i projektów dokumentów ujawnionych przez Zleceniodawcę lub opracowanych przez Strony, lub do których Zleceniobiorca będzie miał dostęp w trakcie podejmowanych czynności w związku z realizacją niniejszej Umową, zarówno przed jak i po wejściu w życie Umowy, a które:
      <ol type="a">
        <li>dotyczą Umowy lub Zleceniodawcy oraz jego działalności, w szczególności wszelkich informacji o charakterze ekonomicznym, handlowym lub organizacyjnym, jak również informacji odnoszących się do jej strategii, personelu i spraw finansowych lub przyszłych planów, lub perspektyw, itp. oraz</li>
        <li>które nie zostały podane do publicznej wiadomości, oraz</li>
        <li>które Zleceniobiorca uzyskał lub które staną mu się znane w czasie obowiązywania niniejszej Umowy, a także przed podpisaniem niniejszej Umowy,</li>
      </ol>
      niezależnie od tego, czy informacje te są w formie pisemnej, ustnej czy w jakiejkolwiek innej formie, jak również niezależnie od tego, czy informacje te, wiedza lub dokumenty są wyraźnie oznaczone, jako poufne (zwane dalej: <strong>„Informacjami Poufnymi”</strong>). Nie dotyczy to informacji, do których ujawnienia Zleceniobiorca zobowiązany zostanie na mocy przepisów prawa.
    </li>
    <li>Obowiązek dochowania tajemnicy trwa także przez okres 3 lat po rozwiązaniu lub wygaśnięciu niniejszej umowy.</li>
    <li>O ile Zleceniodawca nie wskaże inaczej, wyłączne prawo własności wobec wszelkich dokumentów oraz innych nośników informacji poufnych przysługuje Zleceniodawcy, co Zleceniobiorca niniejszym uznaje.</li>
    <li>Informacje Poufne ujawnione przez Zleceniodawcę w okresie obowiązywania niniejszej Umowy lub do których Zleceniobiorca będzie miał dostęp w związku z podejmowanymi czynnościami dotyczącymi realizacji Umowy, będą wykorzystywane wyłącznie w zakresie bezpośrednio związanym z realizacją Umowy. Zleceniobiorca nie jest upoważniony do wykorzystywania Informacji Poufnych w celu prowadzenia własnej działalności gospodarczej lub działalności podmiotów trzecich.</li>
    <li>Po rozwiązaniu niniejszej umowy Zleceniobiorca zobowiązany jest niezwłocznie przekazać Zleceniodawcy znajdujące się w jego posiadaniu: wszystkie pisma, całą korespondencję, projekty oraz wszelkie inne dokumenty dotyczące spraw Zleceniodawcy. Obowiązek zwrotu obejmuje także kopie powyższych dokumentów.</li>
    <li>Ponadto Zleceniobiorca zobowiązany jest po rozwiązaniu umowy  do usunięcia będących w jego posiadaniu lub pod jego kontrolą wszystkich cyfrowych wersji i kopii (włączając w to oryginały)  notatek, wiadomości e-mail, raportów, analiz, podsumowań, dokumentacji projektowej itp., które zawierają lub odzwierciedlają jakiekolwiek informacje poufne Zleceniodawcy, lub jego klientów, bez zachowywania jakichkolwiek kopii; a także do trwałego (nieodwołalnego) wymazania i zniszczenia wszelkich materiałów zawierających lub odzwierciedlających jakiekolwiek poufne informacje Zleceniodawcy, lub jego klientów, które są przechowywane na dowolnym komputerze lub innym urządzeniu będącym w posiadaniu, lub pod kontrolą Zleceniobiorcy.</li>
    <li>Powyższe zobowiązanie dotyczy także usunięcia wszelkich kopii, reprodukcji oraz innych danych wygenerowanych przez Zleceniobiorcę w wyniku otrzymania informacji poufnych, o których mowa powyżej.</li>
    <li>Obowiązki określone w ust. 1- 7 powyżej odnoszą się także do Informacji Poufnych dotyczących potencjalnych klientów Zleceniodawcy, tj. podmiotów, z którymi Zleceniodawca prowadzi negocjacje w celu zawarcia umowy. Dla usunięcia wątpliwości przez prowadzenie negocjacji Strony rozumieją wszelkie czynności podejmowane przez Zleceniodawcę w celu zawarcia umowy, w tym składanie ofert za pośrednictwem Zleceniobiorcy.</li>
    <li>W razie naruszenia przez Zleceniobiorcę ww. zobowiązań, Zleceniobiorca zapłaci Zleceniodawcy karę umowną w wysokości 100 000 zł (słownie: sto tysięcy 0/100) za każde ujawnienie lub wykorzystanie Informacji Poufnych w sposób sprzeczny z postanowieniami niniejszej Umowy. Zleceniodawca jest uprawniony do dochodzenia naprawienia szkody w wysokości przenoszącej zastrzeżoną karę umowną.</li>
  </ol>
  <br>
  
  
<p align="center" style="margin-bottom: 0px;">
      <strong>§ 8 Zakaz konkurencji</strong>
    </p>
    <ol>
      <li>
        Zleceniobiorca jest zobowiązany do powstrzymania się od podejmowania i wykonywania działalności konkurencyjnej wobec Zleceniodawcy, w czasie obowiązywania niniejszej Umowy - zgodnie z definicją opisaną w niniejszym paragrafie.
        </li>
        <li>
          Postanowienia dotyczące zakazu konkurencji, Strony określają szczegółowo w dalszej części niniejszego paragrafu. 
      </li>
      <li>
        Za działalność konkurencyjną w rozumieniu niniejszego paragrafu Strony uznają oferowanie lub świadczenie przez Zleceniobiorcę, na jakiejkolwiek podstawie lub formie, usług edukacyjnych podobnych do usług oferowanych przez Zleceniodawcę, na rzecz klientów Zleceniodawcy, którzy zawarli ze Zleceniodawcą umowę najpóźniej w dniu wygaśnięcia albo rozwiązania niniejszej umowy.
      </li>
      <li>
        Za działalność konkurencyjną uznaje się również:
        <ol type="a">
          <li>
            świadczenie przez Zleceniobiorcę pracy na rzecz podmiotu prowadzącego działalność konkurencyjną wobec Zleceniodawcy (zgodnie z definicją zawartą w ust. 5 niniejszego paragrafu), w tym świadczenie usług na rzecz takich podmiotów na podstawie jakiejkolwiek innej umowy cywilnoprawnej,
          </li>
          <li>
            prowadzenie przez Zleceniobiorcę działalności konkurencyjnej, zgodnie z definicją opisaną w ust. 3, wobec Zleceniodawcy, także za pośrednictwem osób trzecich,
          </li>
          <li>
            bycie wspólnikiem lub członkiem organów spółki prowadzącej działalność konkurencyjną wobec Zleceniodawcy, zgodnie z definicją opisaną w ust. 5,
          </li>
          <li>
            pełnienie funkcji agenta, pełnomocnika lub prokurenta w podmiotach prowadzących działalność konkurencyjną wobec Zleceniodawcy, zgodnie z definicją opisaną w ust. 5.
          </li>
        </ol>
      </li>
      <li>
        Za podmiot prowadzący działalność konkurencyjną wobec Zleceniodawcy uznaje się każdy podmiot, który prowadzi działalność o tożsamym  charakterze do działalności prowadzonej przez Zleceniodawcę, wykorzystując te same lub podobne technologie, które nie są ogólnodostępne (tj. nie są powszechnie znane), oraz działa w oparciu o zbliżony model biznesowy do modelu Zleceniodawcy. Konkurencyjność tych podmiotów polega na tym, że oferują one usługi lub produkty edukacyjne, które mogą być bezpośrednią alternatywą dla usług oferowanych przez Zleceniodawcę, lub mają na celu pozyskanie tych samych klientów, korzystając z podobnych technologii i struktur organizacyjnych.
      </li>
      <li>
        Zleceniobiorca zobowiązuje się, że po wygaśnięciu albo rozwiązaniu niniejszej umowy nie będzie wykorzystywał materiałów, które zostały udostępnione mu przez Zleceniodawcę w trakcie współpracy.
      </li>
      <li>
        W przypadku, gdy w czasie obowiązywania niniejszej Umowy klient Zleceniodawcy złoży Zleceniobiorcy propozycję współpracy, Zleceniobiorca zobowiązany jest poinformować klienta o obowiązującym go zakazie konkurencji i odmówić podjęcia współpracy. Zleceniobiorca ma również obowiązek niezwłocznie poinformować Zleceniodawcę o zaistniałej sytuacji.
      </li>
      <li>
        Zleceniodawca zastrzega sobie prawo do weryfikacji przestrzegania przez Zleceniobiorcę postanowień niniejszego paragrafu.
      </li>
      <li>
        W przypadku naruszenia zakazu konkurencji, Zleceniobiorca zobowiązany jest do zapłaty Zleceniodawcy kary umownej w wysokości 20 000,00 zł (słownie: dwadzieścia tysięcy złotych) za każdy przypadek naruszenia. Zleceniodawcy przysługuje również prawo do dochodzenia odszkodowania na zasadach ogólnych, w wysokości przewyższającej zapłaconą karę umowną.
      </li>
    </ol>
    <br>
  
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 9 [Postanowienia dodatkowe]</strong>
  </p>
  <ol>
    <li>Zleceniobiorca oświadcza, że został zapoznany z przepisami BHP, zagrożeniami związanymi ze świadczonymi Usługami oraz zasadami ochrony przeciwpożarowej w zakresie instruktażu ogólnego i stanowiskowego BHP. Zleceniobiorca potwierdza ten fakt podpisem na karcie Ogólne zasady bhp przy pracy administracyjno-biurowej, która stanowi <strong>Załącznik nr 6</strong> do Umowy.</li>
    <li>Zleceniobiorca oświadcza, że jego stan zdrowia pozwala na świadczenie Usług objętych Umową.</li>
    <li>Zleceniodawca wyraża zgodę na korzystanie przez Zleceniobiorcę w okresie obowiązywania niniejszej Umowy z oznaczenia graficznego TUTORE w celu realizacji niniejszej Umowy.</li>
    <li>Zasady powierzenia Zleceniobiorcy przetwarzania danych osobowych klientów Zleceniodawcy reguluje <strong>Załącznik nr 3</strong> do niniejszej Umowy.</li>
  </ol>
  <br>
  
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 10 [Odpowiedzialność] </strong>
  </p>
  <ol>
    <li>Zleceniobiorca ponosi odpowiedzialność za szkodę wynikłą z niewykonania lub nienależytego wykonania Usług. Zleceniobiorca odpowiada za rzeczywistą, wyrządzoną szkodę oraz za ewentualną utratę korzyści Zleceniodawcy i jest zobowiązany do jej naprawienia w pełnej wysokości.</li>
    <li>Zleceniobiorca ponosi pełną odpowiedzialność wobec osób trzecich w przypadku niewykonania lub też nienależytego wykonania Umowy.</li>
    <li>W przypadku wystąpienia przez osobą trzecią z roszczeniem przeciwko Zleceniodawcy (w tym wytoczenia powództwa lub zgłoszenia się w inny sposób) z tytułu naruszenia praw tej osoby lub osób trzecich, lub obowiązujących przepisów prawa, w wyniku niewykonania lub nienależytego wykonania przez Zleceniobiorcę któregokolwiek z zobowiązań określonych w Umowie, Zleceniobiorca zobowiązany jest bezzwłocznie wesprzeć Zleceniodawcę w obronie przed takim zarzutem i związanym z nim roszczeniem (w tym poprzez dostarczenie niezbędnego materiału dowodowego przeczącego zasadności danego zarzutu) oraz zobowiązuje się zwolnić Zleceniodawcę z obowiązku zaspokojenia takiego roszczenia, jeśli będzie to możliwe zgodnie z obowiązującymi przepisami prawa.</li>
    <li>W przypadku, o którym mowa w ust. 3 powyżej Zleceniobiorca pokryje także wszelkie szkody, które Zleceniodawca poniesie w związku z takim roszczeniem, pozwem lub postępowaniem, w tym:
      <ol type="a">
        <li>koszty postępowania i obsługi prawnej oraz</li>
        <li>równowartości odszkodowania, nałożonych kar lub grzywien, w tym nałożonych na członków zarządu lub pracowników Zleceniodawcy oraz</li>
        <li>koszty wykonania decyzji administracyjnych przez Zleceniodawcę.</li>
      </ol>
    </li>
    <li>Powyższe zobowiązania stosuje się odpowiednio w razie wszczęcia wobec Zleceniodawcy postępowania, w tym karnego lub administracyjnego, w wyniku niewykonania lub nienależytego wykonania przez Zleceniobiorcę któregokolwiek z zobowiązań wynikających z Umowy.</li>
  </ol>
  <br>
  
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 11 [Klauzula antykorupcyjna]</strong>
  </p>
  <ol>
    <li>Zleceniobiorca przyjmuje do wiadomości, że jedną z zasad działalności Zleceniodawcy jest przestrzeganie zakazu bezpośredniego lub pośredniego przekazywania jakichkolwiek korzyści majątkowych osobom pełniącym funkcje publiczne, lub instytucjom publicznym i państwowym, w celu uzyskania lub utrzymania korzyści handlowych i zobowiązuje się do przestrzegania tej zasady. Na potrzeby niniejszej umowy, za osobę pełniąca funkcje publiczną rozumie się w szczególności dyrektora i nauczyciela szkoły publicznej lub prywatno-publicznej, zaś za instytucję publiczną – szkołę publiczną lub prywatno-publiczną.</li>
    <li>Zleceniobiorca przyjmuje do wiadomości, że stosowne przepisy prawa zabraniają, m.in. bezpośredniego lub pośredniego przekazywania korzyści majątkowych, lub osobistych funkcjonariuszom publicznym, osobom pełniącym funkcje publiczne oraz innym urzędnikom państwowym, a także partiom politycznym lub ich kandydatom w celu uzyskania lub utrzymania korzyści biznesowych i zobowiązuje się przestrzegać te zasady.</li>
    <li>Zleceniobiorca zobowiązuje się przestrzegać zasad opisanych powyżej, w tym oświadcza, że wynagrodzenie, o którym mowa w § 4 niniejszej Umowy, jest świadczeniem ekwiwalentnym w stosunku do świadczeń wykonanych przez Zleceniobiorcę na podstawie Umowy i nie narusza zasad opisanych w ustępach poprzedzających.</li>
    <li>Zleceniobiorca oświadcza, że nie pozostaje w żadnej relacji służbowej lub osobistej, która mogłaby powodować podejrzenie, że zawarcie Umowy będzie sprzeczne z opisanymi powyżej zasadami. W przypadku podejrzenia zaistnienia takiej relacji, Zleceniobiorca zobowiązuje się niezwłocznie powiadomić o tym fakcie Zleceniodawcę. W takim przypadku Zleceniodawcy przysługuje prawo do natychmiastowego rozwiązania Umowy.</li>
  </ol>
  <br>
  
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 12 [Postanowienia końcowe]</strong>
  </p>
    <ol>
      <li>Zmiana lub uzupełnienie niniejszej umowy wymaga formy pisemnej pod rygorem nieważności.</li>
      <li>W sprawach nieuregulowanych niniejszą umową odpowiednie zastosowanie mają przepisy prawa w tym Kodeksu cywilnego.</li>
      <li>W przypadku stwierdzenia, iż niniejsza Umowa, w części lub w całości, jest nieskuteczna prawnie z jakichkolwiek powodów, strony zobowiązują się do dokonania takich zmian jej treści, by nieskuteczność ową usunąć.</li>
      <li>Jeżeli w czasie trwania Umowy stan prawny, który obowiązywał w czasie zawierania Umowy, zmieni się w ten sposób, że zmieni się znaczenie, jakie strony nadały poszczególnym postanowieniom Umowy, a z przepisów prawa będzie wynikało, iż nowy stan prawny ma zastosowanie do stosunków prawnych regulowanych Umową, Strony zobowiązują się do stosownej zmiany całości lub części Umowy, tak aby przywrócić jej pierwotne znaczenie.</li>
      <li>Wszelkie spory wynikające z niniejszej Umowy lub z nią związane będą rozstrzygane na drodze polubownej, a w przypadku braku porozumienia pomiędzy stronami zostaną poddane rozstrzygnięciu przez sąd powszechny właściwy dla siedziby Zleceniodawcy.</li>
      <li>Umowę sporządzono w dwóch jednobrzmiących egzemplarzach po jednym dla każdej ze Stron.</li>
      <li>Integralną część Umowy stanowią:
        <ul style="list-style-type: none;">
          <li>Załącznik 1 - Szczegółowy zakres czynności</li>
          <li>Załącznik 2 - Klauzula informacyjna RODO</li>
          <li>Załącznik 3 - Upoważnienie do przetwarzania danych osobowych w zbiorze w wersji papierowej i elektronicznej</li>
          <li>Załącznik nr 4 - Pełnomocnictwo</li>
          <li>Załącznik 5 - Zgoda na wykorzystanie wizerunku</li>
          <li>Załącznik 6 - OGÓLNE ZASADY BHP PRZY PRACY ADMINISTRACYJNO-BIUROWEJ</li>
          <li>Załącznik nr 7  - Oświadczenie Zleceniobiorcy dla celów ubezpieczeń</li>
          <li>Załącznik nr 8 - Kopia pełnomocnictwa</li>
        </ul>
      </li>
    </ol>
  <br>

  <table style="width: 100%; border: 1px solid black;">
    <tr>
      <td align="center">PODPISY STRON</td>
    </tr>
  </table>

  <table style="width: 100%; border: 1px solid black;">
    <tr style="border-bottom: 2px solid black;">
      <td align="center" style="border-right: 2px solid black;">ZLECENIODAWCA</td>
      <td align="center">ZLECENIOBIORCA</td>
    </tr>
    <tr style="height: 100px;">
      <td style="border-right: 2px solid black;">
        <p align="center" style="margin-top: 45px;">{{ zamawiajacy }}</p>
      </td>
      <td>
        <p align="center" style="margin-top: 45px;">{{ imieNazwisko }}</p>
      </td>
    </tr>
  </table>

  <div style="margin-top:40px; page-break-before: always;">
      <p style="font-size: 16px;"><strong>Załącznik nr 1. SZCZEGÓŁOWY ZAKRES CZYNNOŚCI ZLECENIOBIORCY</strong></p>
      <p>W ramach świadczenia Usług Zleceniobiorca zobowiązuje się do wykonywania czynności związanych z pozyskaniem nowych klientów dla Zleceniodawcy, a w szczególności do:</p>
        <ol>
          <li>Reprezentowania Zleceniodawcy wobec osób prywatnych, firm i instytucji.</li>
          <li>Administrowania całego procesu pozyskania nowego klienta (m. in. utrzymywanie stałego kontaktu z placówkami wskazanymi przez Zleceniodawcę, pozyskiwanie nowych klientów)</li>
          <li>Prezentowania oferty usług i produktów z oferty Zleceniodawcy potencjalnym klientom w szkołach i innych placówkach bądź firmach oraz klientom indywidualnym.</li>
          <li>Negocjowania umów najmu oraz umów o prowadzenie kursów językowych oraz innych kursów edukacyjnych oraz zawierania tych umów w imieniu Zleceniodawcy w zakresie objętym pełnomocnictwem; </li>
          <li>Prowadzenia działań związanych ze sprzedażą i promocją produktów i usług oferowanych przez Zleceniodawcę, w tym organizowanie akcji promocyjnych, badanie rynku i konkurencji na powierzonym obszarze.</li>
          <li>Realizacji celów budżetowych i jakościowych ustalonych ze Zleceniodawcą</li>
          <li>Udziału w rekrutacji zespołu współpracowników do realizacji zleconych Usług tj. hostess, animatorów, lektorów i promotorów.</li>
          <li>Coachingu i nadzoru nad wykonywanymi zadaniami przez podległy zespół.</li>
          <li>Sporządzania cyklicznych raportów i podsumowań z pracy własnej oraz podległego zespołu.</li>
          <li>Realizacji innych zadań zleconych przez Zleceniodawcę.</li>
        </ol>
    </div>

    <div style="page-break-before: always;">
    <p><strong>Załącznik nr 2. KLAUZULA INFORMACYJNA</strong></p>
    <p style="margin-bottom: 8px;">Zgodnie z art. 13 ust. 1 i 2 rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych) (Dz. Urz. UE L 119 z 04.05.2016, str. 1), dalej „RODO”, informuję, że:</p>
    <p style="margin-bottom: 8px;">Administratorem Pani/Pana danych osobowych jest Tutore Poland Sp. z o.o., z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440, KRS 0000670834, zwany dalej: „ADO”.</p>
    <p style="margin-bottom: 8px;">Może Pan/Pani kontaktować się z ADO pisząc na adres: Tutore Poland Sp. z o.o, ul. Piotrkowska 157A, 90-440, mail kadry@tutore.eu</p>
    <p style="margin-bottom: 8px;">ADO przetwarza dane osobowe w celu:</p>
    <ol style="margin-bottom: 8px;">
      <li>nawiązania współpracy - Art. 6 ust. 1 lit. b, f RODO,</li>
      <li>zapewnienia kontaktu pomiędzy Stronami (adres e – mail, nr telefonu) - Art. 6 ust. 1 lit. b, f RODO,</li>
      <li>realizacji praw i obowiązków wynikających z umowy o świadczenie usług - Art. 6 ust. 1 lit. b, c, f RODO,</li>
      <li>prowadzenia rejestru korespondencji - Art. 6 ust. 1 lit. c, f RODO,</li>
      <li>ewidencji przebiegu współpracy (w tym realizacja płatności) - Art. 6 ust. 1 lit. b, c RODO,</li>
      <li>dochodzenia roszczeń i praw - Art. 6 ust. 1 lit. b, f RODO</li>
      <li>realizacji obowiązków podatkowych - Art. 6 ust. 1 lit. b, c RODO,</li>
    </ol>
    <p style="margin-bottom: 8px;">Odbiorcami danych osobowych są podmioty, którym ADO powierzył przetwarzanie danych osobowych, w szczególności: dostawcy usług technicznych i organizacyjnych, dostawcy usług księgowych, kadrowych, prawnych i doradczych, banki (realizacja płatności), organy publiczne w ramach realizacji obowiązków związanych z prowadzeniem działalności gospodarczej przez ADO.</p>
    <p style="margin-bottom: 8px;">Dane osobowe przechowywane będą przez odpowiedni okres wskazany w ust. 2. Po upływie tego okresu dane osobowe przechowywane w systemach informatycznych podlegają usunięciu, a nośniki informacji przechowujące dane, podlegają zniszczeniu.</p>
    <p style="margin-bottom: 8px;">ADO nie przekazuje danych osobowych poza Europejski Obszar Gospodarczy.</p>
    <p style="margin-bottom: 8px;">Dane osobowe przechowywane będą przez okres realizacji umowy, a następnie przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa, w tym w szczególności: dochodzenie roszczeń (okres przedawnienia roszczeń), prowadzenie ksiąg rachunkowych i dokumentacji podatkowej (5 lat od końca roku kalendarzowego, w którym powstał obowiązek podatkowy).</p>
    <p>Osoba, której dane są przetwarzane ma prawo dostępu do swoich danych oraz otrzymania ich kopii, prawo do sprostowania (poprawiania) swoich danych, prawo do usunięcia danych, prawo do cofnięcia zgody, prawo do ograniczenia przetwarzania, prawo do bycia zapomnianym, prawo do sprzeciwu, prawo do przenoszenia danych, prawo do wniesienia skargi do Urzędu Ochrony Danych Osobowych.</p>
    <p>Podanie przez Panią/Pana danych osobowych oraz zgoda na ich przetwarzanie i rozpowszechnianie wizerunku jest dobrowolne, ale stanowi warunek konieczny dla nawiązania współpracy i ewentualnego zawarcia umowy w formie pisemnej oraz realizacji praw i obowiązków przez ADO.</p>
    <p>W ramach działalności ADO nie dochodzi do zautomatyzowanego podejmowania decyzji, w tym profilowania, z wykorzystaniem zebranych danych osobowych.</p>
    <p>Zakres danych podlegający przetwarzaniu: imię i nazwisko, adres mailowy, numer telefonu, wizerunek, PESEL.</p>
      <div class="right-cointainer" style="float: right;">
          <span>{{ imieNazwisko }}</span>
          <br>
          <span><strong>Podpis Zleceniobiorcy</strong></span>
      </div>
    </div>

    <div style="margin-top:40px; page-break-before: always;">
    <p style="font-size: 16px;"><strong>Załącznik nr 3</strong></p>
      <p align="center" class="subheading">
        <strong>
          Upoważnienie
          <br/>
          do przetwarzania danych osobowych w zbiorze w wersji
          <br/>
          elektronicznej
        </strong>
      </p>
  <p>Na podstawie art. 29 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej RODO, niniejszym:</p>
  <p>z dniem podpisania upoważnienia przez obie strony</p>
  <p>upoważniam Pana/Panią {{ imieNazwisko }} – Zleceniobiorcę Tutore Poland Sp. z o.o.</p>
  <p>do przetwarzania danych osobowych zawartych w poniżej wymienionych zbiorach danych osobowych:</p>
  <p>w wersji elektronicznej:</p>
    <ul>
      <li>zbiór danych osobowych potencjalnych Klientów pozyskanych z baz Present-Service i Marketing Relacji w celach telemarketingowych – imię i nazwisko, telefon kontaktowy,</li>
      <li>zbiór danych osobowych Uczestników: dzieci, młodzieży i dorosłych korzystających z usług prowadzonych przez Tutore Poland Sp. z o.o. - imię i nazwisko, klasa (jeśli dotyczy), adres zamieszkania,</li>
      <li>zbiór danych osobowych Klientów: rodziców (opiekunów prawnych) dzieci i młodzieży korzystających z usług oferowanych przez Tutore Poland Sp. z o.o. – imię i nazwisko, adres zamieszkania, telefon kontaktowy, adres e-mail,</li>
      <li>zbiór nagrań audio rozmów telefonicznych prowadzonych przez konsultantów Call Center z Klientami wyłącznie trakcie szkoleń – imię i nazwisko, głos,</li>
      <li>zbiór danych osobowych Kandydatów aplikujących w celu zatrudnienia przez Tutore Poland Sp. z o.o. na czynności związane z prowadzeniem zajęć  - CV zawierające m.in. imię i nazwisko, adres zamieszkania, telefon kontaktowy, adres e-mail,</li>
      <li>zbiór danych osobowych Zleceniobiorców zatrudnionych przez Tutore Poland – imię i nazwisko, adres zamieszkania, telefon kontaktowy, adres e-mail.</li>
    </ul>
  <p>w zakresie wglądu, wprowadzania, modyfikacji, usuwania i archiwizacji danych osobowych objętych wyżej wymienionymi zbiorami.</p>
  <p>Niniejsze upoważnienie nie upoważnia do udzielania dalszych upoważnień i wygasa z dniem ustania umowy zlecenia, a ponadto może być w każdym czasie zmienione lub odwołane.</p>
  <p>Zobowiązuję Pana/Panią do przetwarzania danych osobowych zawartych w ww. zbiorach danych osobowych w zakresie i w sposób wymagany do wypełnienia obowiązków służbowych względem Zleceniodawcy - Administratora Danych Osobowych. Zobowiązuję Pana/Panią do przetwarzania danych osobowych zgodnie z udzielonym upoważnieniem, rozporządzeniem Parlamentu Europejskiego i Rady (UE)2016/679 z 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE ( Dz. Urz. UE L 119, s.1) oraz przepisami ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych (Dz.U. z 2018 r. poz.1000) i obowiązującymi w Tutore Poland Sp. z o.o..wewnętrznymi regulacjami w sprawie ochrony danych osobowych.
Naruszenie ww. obowiązków może skutkować poniesieniem odpowiedzialności karnej oraz stanowi podstawę do rozwiązania umowy zlecenie.</p>
  </div>
  
    <div class="container" style="page-break-before: always;">
      <table style="border: 1px solid; text-align: left; font-size: 14px; width: 100%;">
        <tr>
          <td id="oswiadczenie">
            <p align="center" class="subheading"><strong>OŚWIADCZENIE ZLECENIOBIORCY</strong></p>
          Ja niżej podpisany/a oświadczam, iż:
          <ol type="a">
            <li>zapoznałem/am się z Informacją o monitoringu rozmów telefonicznych oraz Klauzulą Informacyjną i przyjmuję ją do wiadomości,</li>
            <li>treść Informacji i Klauzuli jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi wyjaśnione przez osobę upoważnioną w sposób wyczerpujący.</li>
            </ol>
            <br>
            <div class="right-cointainer" style="float: right;">
          {{ imieNazwisko }}
          <br>
          <span>czytelny podpis Zleceniobiorcy</span>
          </div>
        </td>
      </tr>
    </table>
    </div>

    <div style="margin-top:40px; page-break-before: always;">
      <p style="font-size: 16px; margin-bottom: 0;"><strong>Załącznik nr 4. PEŁNOMOCNICTWO</strong></p>
      <p align="right" style="font-size: 14px; margin-bottom: 0;">
        Łódź, dnia {{ aktualnaData() }} r.
      </p>
      <p style="margin-bottom: 8px;">Tutore Poland Sp. z o.o.,</p>
      <p style="margin-bottom: 8px;">ul. Piotrkowska 157A,</p>
      <p style="margin-bottom: 8px;">90-440 Łódź</p>
      <p>KRS 0000670834</p>
      <p align="center" style="letter-spacing: 0.3rem;"><strong>PEŁNOMOCNICTWO</strong></p>
      <p>Działając w imieniu i na rzecz <strong>TUTORE POLAND spółka z ograniczoną odpowiedzialnością z siedzibą w Łodzi</strong>, niniejszym udzielam {{ imieNazwisko }} (<strong>PESEL</strong> {{ pesel }}), pełnomocnictwa do:</p>
      <ul class="dashed">
        <li>negocjacji, zawierania, rozwiązywania i wypowiadania umów najmu oraz umów o prowadzenie kursów językowych oraz innych kursów edukacyjnych, <strong>do kwoty 10.000,00 zł (słownie 10.000 złotych) netto</strong>, przy czym w przypadku umów zawieranych na czas określony jako wartość umowy przyjmuje się kwotę łączną świadczeń pieniężnych za cały okres obowiązywania umowy, a w przypadku umów na czas nieokreślony – kwotę łączną świadczeń pieniężnych za okres 1 (jednego) roku kalendarzowego;</li>
        <li>wprowadzania zmian i zawierania aneksów do umów najmu oraz umów o prowadzenie kursów językowych oraz innych kursów edukacyjnych;</li>
        <li>dokonywania czynności związanych z wydawaniem i zdawaniem lokali będących przedmiotem najmu, w tym sporządzania i podpisywania wszelkiego rodzaju dokumentów, w szczególności protokołów zdawczo-odbiorczych.</li>
      </ul>
      <p>Pełnomocnictwo niniejsze obejmuje umocowanie do składania oświadczeń materialnoprawnych oraz dokonywania wszelkich czynności faktycznych i prawnych, które okażą się niezbędne i konieczne.</p>
    </div>
  
   <div style="margin-top:5px; page-break-before: always;">
     <p><strong>Załącznik nr 5. ZGODA NA WYKORZYSTANIE WIZERUNKU</strong></p>
     <p>Ja, niżej podpisany/a: {{ imieNazwisko }} wyrażam nieodpłatnie zgodę na:</p>
    <ol>
      <li>Przetwarzanie przez Tutore Poland Sp. z o.o., z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440, KRS 0000670834, NIP: 727-28-12-193, REGON: 366891567, (dalej: Tutore Poland Sp. z o.o.) mojego wizerunku utrwalonego w dniu {{ aktualnaData() }} w formach i celach określonych w pkt 2 poniżej;</li>
      <li>udostępnianie i rozpowszechnianie przez Tutore Poland mojego wizerunku utrwalonego w sposób określony powyżej w następujących formach i celach:
        <ul class="dashed">
          <li>publikacja w stopce e-mail maila służbowego;</li>
          <li>publikacja na stronie internetowej Spółki, dostępnej pod adresem www.tutore.eu,</li>
          <li>publikacja w materiałach reklamowych i ofertach handlowych;</li>
          <li>publikacja w social mediach Spółki (Facebook, Instagram, YouTube) </li>
        </ul>
        w celach informacyjnych, promocyjnych i marketingowych związanych z prowadzoną przez Spółkę działalnością.
      </li>
      <li>przetwarzanie mojego wizerunku poprzez kadrowanie i kompozycję.</li>
    </ol>
     <p>Jednocześnie oświadczam, że zostałem/am poinformowany/a, że wyrażenie zgody na wykorzystanie mojego wizerunku jest dobrowolne.</p>
     <p>Administratorem danych osobowych objętych niniejszym Oświadczeniem jest Tutore Poland Sp. z o.o., z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440, KRS 0000670834, NIP: 727-28-12-193, REGON: 366891567)	
Zostałem/am pouczony/a o:</p>
      <ul class="dashed">
        <li>prawie do wycofania zgody na przetwarzanie danych osobowych objętych niniejszym Oświadczeniem, przy czym jej wycofanie nie wpłynie na legalność wcześniejszego przetwarzania;</li>
        <li>prawie dostępu do treści swoich danych, do zmiany swoich danych osobowych lub ich usunięcia lub sprostowania, prawo żądania ograniczenia przetwarzania, a także w określonych przypadkach prawie żądania przenoszenia danych, wniesienia sprzeciwu wobec przetwarzania, a ponadto prawie wniesienia skargi do organu nadzorczego;</li>
        <li>podstawie przetwarzania danych osobowych, tj. zgodzie (art. 6 ust. 1 lit. a Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE);</li>
        <li>możliwości przekazania moich danych innym odbiorcom, tj. w szczególności serwisom internetowym (w tym portalom Facebook, Instagram i Youtube), a także współpracownikom i kontrahentom administratora;</li>
        <li>czasie przetwarzania moich danych osobowych, które będą przez administratora przechowywane do czasu wycofania udzielonej przeze mnie zgody lub wcześniej, jeśli nie będą już niezbędne do celu, w którym zostały zebrane.</li>
      </ul>
      <div style="width: 50%; display: inline-block; margin-top: 30px;">
        <p align="center" style="margin-bottom: 0;">{{ imieNazwisko }}</p>
        <p align="center"><em>(podpis)</em></p>
      </div>
      <div style="float: right; width: 50%; display: inline-block; margin-top: 30px;">
        <p align="center" style="margin-bottom: 0;">{{ aktualnaData() }}</p>
        <p align="center"><em>(data i miejsce złożenia podpisu)</em></p>
      </div>
    </div>

    <div style="margin-top: 5px; page-break-before: always;">
  <p><em><b>Załącznik nr 6</b></em></p>
  <p class="subheading" style="margin-bottom: 0px;"><strong>OGÓLNE ZASADY BHP PRZY PRACY ADMINISTRACYJNO-BIUROWEJ</strong></p>
  <br>
  <p style="margin-bottom: 8px;">Bezpieczne warunki pracy są zapewnione, gdy:</p>
  <ul style="margin-bottom: 8px;">
    <li>Zapewniona jest dostatecznie duża powierzchnia stanowiska pracy (co najmniej 2m wolnej powierzchni podłogi).</li>
    <li>Jest właściwe oświetlenie (w zależności od charakteru pracy min. 300lx).</li>
    <li>Jest dostateczna wentylacja pomieszczenia (naturalna lub mechaniczna); wilgotność względna powietrza nie powinna być mniejsza niż 40%.</li>
    <li>Jest wystarczające ogrzewanie w okresie jesienno-zimowym (min. +18°C)</li>
    <li>Są dostępne i w dobrym stanie urządzenia higieniczno-sanitarne oraz dobry stan techniczny mebli, sprzętu i innych urządzeń.</li>
  </ul>
  <p style="margin-bottom: 8px;">Podstawowe czynności, które należy wykonać przed rozpoczęciem pracy:</p>
  <ul style="margin-bottom: 8px;">
    <li>Zaplanować  kolejność wykonywania poszczególnych czynności, przygotować potrzebne dokumenty i programy.</li>
    <li>Ustawić ekran monitora względem źródeł światła tak, aby ograniczyć olśnienie i odbicia światła.</li>
    <li>Sprawdzić stan techniczny mebli, sprzętu, urządzeń, stan oświetlenia stanowiska pracy.</li>
    <li>Zaznajomić się dokładnie z instrukcją obsługi i instrukcją bezpiecznej pracy sprzętu elektrycznego i elektronicznego używanego w trakcie wykonywania pracy (komputer, drukarka, itp.).</li>
    <li>Odpowiednio dla siebie dopasować krzesło i przygotować stanowisko pracy.</li>
  </ul>
  <p style="margin-bottom: 8px;">Czynności, które należy wykonywać podczas pracy:</p>
  <ul style="margin-bottom: 8px;">
    <li>Utrzymywać ład i porządek na stanowisku pracy.</li>
    <li>Zachowywać ostrożność przy używaniu urządzeń elektrycznych.</li>
  </ul>
  <p style="margin-bottom: 8px;">Czynności zabronione:</p>
  <ul style="margin-bottom: 8px;">
    <li>Dopuszczenia do użytkowania urządzeń osób nieupoważnionych.</li>
    <li>Otwierania osłon podczas pracy urządzeń.</li>
    <li>Używania niesprawnych bądź uszkodzonych urządzeń, względnie instalacji elektrycznej (np. zniszczona izolacja na przewodach, stłuczone wtyczki lub gniazdka, prowizorycznie połączone przewody). </li>
  </ul>
  <p style="margin-bottom: 8px;">Uwagi końcowe:</p>
  <ul>
    <li>
        Przy stałej pracy przy komputerze należy:
        <ul>
            <li>łączyć przemiennie prace związana z obsługą monitora ekranowego z innymi rodzajami prac nie obciążającymi narządu wzroku i wykonywanymi  w innych pozycjach ciała – przy nieprzekraczaniu 1 godziny nieprzerwanej pracy przy obsłudze monitora ekranowego lub</li>
            <li>co najmniej 5-minutową przerwę, wliczaną do czasu pracy, po każdej godzinie pracy przy obsłudze monitora ekranowego.</li>
        </ul>
    </li>
  </ul>
  <p style="margin-top: 30px;">Oświadczam, iż zapoznałem się i akceptuję powyższa zasady bhp przy pracy administracyjno-biurowej.</p>
  <div class="right-cointainer" style="float: right;">
          <span>{{ imieNazwisko }}</span>
          <br>
          <span>Podpis Zleceniobiorcy</span>
      </div>
</div>


  
      <div style="margin-top:5px; page-break-before: always;">
    <p><strong>Załącznik nr 7 Oświadczenie Zleceniobiorcy dla celów ubezpieczeń</strong></p>
    <p align="center" class="subheading">Oświadczenie Zleceniobiorcy</p>
  
    <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
    <tbody>
  
    <tr>
    <td style="border: 1px solid; background-color: #a4c2f4; text-align: center; width: 300px;">
    <p class="cell-in-first-table"><span><strong>DANE OSOBOWE</strong></span></p>
    </td>
    <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
    <p class="cell-in-first-table"><span><strong>DO WYPEŁNIENIA</strong></span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Data</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{data}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Imiona i Nazwisko</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{imieNazwisko}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Numer PESEL</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{pesel}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Seria i numer dowodu osobistego (proszę podać w przypadku braku nr PESEL)</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{nrDowodu}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Obywatelstwo</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{obywatelstwo}}</span></p>
    </td>
    </tr>

    <tr v-if="obywatelstwoA">
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>A. Posiadam na terytorium Rzeczypospolitej Polskiej centrum interesów osobistych lub gospodarczych (ośrodek interesów życiowych*):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{obywatelstwoA}}</span></p>
  </td>
  </tr>

  <tr v-if="obywatelstwoB">
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>B. Przebywam na terytorium Rzeczypospolitej Polskiej dłużej niż 183 dni w roku kalendarzowym (podatkowym):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{obywatelstwoB}}</span></p>
  </td>
  </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Numer telefonu</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{nrTelefonu}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Adres e-mail</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{email}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Adres zamieszkania</span><br><span class="caption"> (ulica, nr domu, kod pocztowy, miejscowość)</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table bigCell"><span>{{adresZamieszkania}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Adres korespondencyjny</span><br><span class="caption"> (ulica, nr domu, kod pocztowy, miejscowość)</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{adresKorespondencyjny}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Urząd Skarbowy <br>(zgodny z adresem zamieszkania)</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table bigCell"><span>{{urzadSkarbowy}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Numer rachunku bankowego</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{nrRachunku}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
    <p class="cell-in-first-table"><span><strong>OŚWIADCZAM, ŻE:</strong></span></p>
    </td>
    <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
    <p class="cell-in-first-table"><span><strong>ODPOWIEDZI: „TAK” lub „NIE”<br>(lub opis, jeśli jest wymagany)</strong></span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>1. Jestem emerytem</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{emeryt}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>2. Jestem rencistą</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{rencista}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>3. Posiadam orzeczenie o stopniu niepełnosprawności</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{orzeczenieNiepelnosprawnosc}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>3.1. Jeśli wpisano "TAK", proszę określić orzeczony stopień niepełnosprawności</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{stopienNiepelnosprawnosc.replace(/\s*\(.*$/, '')}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>4. Jestem uczniem/studentem do 26 roku życia (nie dotyczy studiów doktoranckich, podyplomowych):</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{student}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>5. Wnoszę o dobrowolne ubezpieczenie chorobowe (tylko w przypadku objęcia obowiązkowym ubezpieczeniem emerytalnym i rentowym):</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{chorobowe.replace(/\s*\(.*$/, '')}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>6. Jestem zatrudniony/a na umowę o pracę lub umowę zlecenie<br>(Jeśli wpisano "TAK", proszę uzupełnić poniższe dane)</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{zatrudnionyUmowaPraca.replace(/\s*\(.*$/, '')}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>6.1. Nazwa i adres pracodawcy/zleceniodawcy poza Tutore Poland Sp. z o.o. (proszę wypełnić w przypadku odpowiedzi TAK w pkt. 6):</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{nazwaUmowaPraca}}</span></p>
    </td>
    </tr>
  
    <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6.2. Wynagrodzenie z tytułu umowy o pracę/umowy zlecenie w innym miejscu niż Tutore Poland Sp. z o.o. jest wyższe bądź równe krajowej płacy minimalnej.</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{wynagrodzenieUmowaPraca.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>
  
    <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6.3. Wnoszę o dobrowolne ubezpieczenie emerytalne i rentowe (tylko w przypadku odpowiedzi TAK w pkt. 6 i 6.2):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{wniosekUbezpieczenie.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>7. Podlegam ubezpieczeniu społecznemu z innego tytułu niż umowa zlecenie z Tutore Poland Sp. z o.o. (np. zasiłek macierzyński, rodzicielski, urlop wychowawczy, własna pozarolnicza działalność gospodarcza):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{ubezpieczenieUmowaPraca}}</span></p>
  </td>
  </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>7.1. W przypadku odpowiedzi: TAK, proszę określić tytuł ubezpieczenia</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{tytulUbezpieczenieUmowaPraca}}</span></p>
    </td>
    </tr>
  
    <tr>
  <td colspan="2" style="border: 1px solid; background-color: #a4c2f4; text-align: center; font-size: 10px">
  <p class="cell-in-first-table"><span style="font-size: 12px"><strong>
  Wypełnienie powyższego oświadczenia oznacza deklarację zgodności wypisanych danych ze stanem prawnym oraz faktycznym,oraz świadomość odpowiedzialności karnej za zeznanie nieprawdy lub zatajenie prawdy.
  <br/>
  W przypadku zmiany ww. danych w trakcie trwania umowy zlecenie, zobowiązuję się do poinformowania Zleceniodawcy w terminie 7 dni od daty zaistnienia zmiany. Wszelkie szkody wynikające ze zmiany treści oświadczeń zobowiązuje się pokryć z własnych środków.
  <br/>
  </strong></span></p>
  </td>
  </tr>
  
    </tbody>
    </table>
    </div>
    
    </td></tr>
    </tbody></table>
  
    </v-container>
  </template>
  
  <script>
  export default {
    name: 'UmowaManager.vue',
    props: {
    },
    data () {
      return {
        ulica: '',
        nrDomu: '',
        nrLokalu: '',
        miejscowosc: '',
        kodPocztowy: '',
        pesel: '',
        nrRachunku: '',
        nrDowodu: '',
        obywatelstwo: '',
        nrTelefonu: '',
        email: '',
        urzadSkarbowy: '',
        emeryt: '',
        rencista: '',
        orzeczenieNiepelnosprawnosc: '',
        stopienNiepelnosprawnosc: '',
        student: '',
        chorobowe: '',
        zatrudnionyUmowaPraca: '',
        nazwaUmowaPraca: '',
        wynagrodzenieUmowaPraca: '',
        ubezpieczenieUmowaPraca: '',
        tytulUbezpieczenieUmowaPraca: '',
        stanowisko: '',
        oddzial: '',
        zamawiajacy: '',
        sprzetSluzbowy: '',
        samochodSluzbowy: '',
        okresWypowiedzenia: '',
        kwota: '',
        slownieKwota: '',
        nrUmowy: '',
        imieNazwisko: '',
        data: '',
        umowaOd: '',
        umowaDo: '',
        adresZamieszkania: '',
        adresKorespondencyjny: '',
        maksimumGodzin: '',
        ubezpieczenieEmerytalne: '',
        obywatelstwoA: '',
        obywatelstwoB: '',
        wniosekUbezpieczenie: '',
      }
    },
    created () {
      Object.entries(this.$route.query).forEach(
        ([key, value]) => { this[key] = value }
      )
    },
    methods: {
      shortNrUmowy () {
        let tab = []
        tab = this.nrUmowy.split('/')
        const shortUmowa = `${tab[2]}`
        return shortUmowa
      },
      okresWypowiedzeniaEdited () {
        let text = '';
        switch (this.okresWypowiedzenia) {
          case '5 dni roboczych':
            text = '5-dniowego'
            break
          case '7 dni roboczych':
            text = '7-dniowego'
            break
          case '14 dni roboczych':
            text = '14-dniowego'
            break
        }
        return text
      },
      dataStartuUmowy () {
          if (this.umowaOd === '30-12-1899') {
            return `od dnia podpisania umowy przez obie strony`
          } else {
            return `od ${this.umowaOd} r.`
          }
      },
      dataZakonczeniaUmowy () {
          if (this.umowaDo === '30-12-1899') {
            return `do dnia zakończenia umowy`
          } else {
            return `do ${this.umowaDo} r.`
          }
      },
      aktualnaData() {
        const today = new Date();
        let day = today.getDate();
        if((day+1) <= 10) {
          day = '0' + day
        }
        let month = today.getMonth()+1;
        if ((today.getMonth()+1) < 10) {
          month = '0' + month
        } 
        const todayDate = day+'-'+month+'-'+today.getFullYear()
        return todayDate
      }
    },
    mounted () {
      if (this.zamawiajacy) {
        this.$nextTick(() => {
          window.setTimeout(() => window.print(), 300)
        })
      }
    }
  }
  </script>
  
  <style scoped>
  
  .page {
    size: 210mm 297mm;
    background-size: 100% 100%;
    line-height: 1.4;
    text-align: justify;
    margin-top: 2px;
    padding-top: 0px;
  }
  
  table {
    border: 1px;
    border-collapse: collapse;
    table-layout: fixed;
  }
  
  th, td {
    border: 1px;
    border-collapse: collapse;
  }
  
  .cointainer {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  
  .cointainer-left {
    width: 20%;
  }
  
  .cointainer-right {
    width: 20%;
  }
  
  thead {
    display: table-header-group;
  }
  
  .table-border {
    border: 1px solid black;
    border-collapse: collapse;
    padding: 5px;
  }
  
  .cell-in-first-table {
    margin-top: 2px;
    margin-bottom: 2px;
    margin-left: 10px;
    margin-right: 10px;
  }
  
  ul.dashed {
    list-style-type: "- ";
    margin: 0;
  }
  
  .underline {
    text-decoration: underline;
  }
  
  .pageNum {
    position: absolute;
    right: 0px;
    font-size: 14px;
  }
  
  #oswiadczenie {
    padding: 20px;
  }
  
  .p-margin {
    margin-bottom: 5px !important;
  }

  </style>
  


// WEBPACK FOOTER //
// src/components/UmowaManager.vue